import { mockHeroBanners, normalizeHeroBanners, type HeroBanner } from '../mocks/heroBanners';
import { STORAGE_KEYS, readStoredJSON, writeStoredJSON } from './state/appState';

export function loadStoredHeroBanners() {
  return normalizeHeroBanners(readStoredJSON<HeroBanner[]>(STORAGE_KEYS.heroBanners, mockHeroBanners));
}

export function saveStoredHeroBanners(items: HeroBanner[]) {
  writeStoredJSON(STORAGE_KEYS.heroBanners, normalizeHeroBanners(items));
}

export function sanitizeLegacyHeroBannersInStorage() {
  if (typeof window === 'undefined') {
    return false;
  }

  const storedRaw = readStoredJSON<HeroBanner[]>(STORAGE_KEYS.heroBanners, mockHeroBanners);
  const sanitized = normalizeHeroBanners(storedRaw);
  const nextPayload = JSON.stringify(sanitized);

  if (window.localStorage.getItem(STORAGE_KEYS.heroBanners) === nextPayload) {
    return false;
  }

  window.localStorage.setItem(STORAGE_KEYS.heroBanners, nextPayload);
  return true;
}
